// External dependencies
import PropTypes from 'prop-types';
import React from 'react';

export default function DashboardStats({ stats }) {
  if (!stats) {
    return null;
  }

  const statCards = [
    {
      title: 'Total Users',
      value: stats.totalUsers || 0,
      icon: '👥',
      color: '#4CAF50',
    },
    {
      title: 'Active Users',
      value: stats.activeUsers || 0,
      icon: '✅',
      color: '#2196F3',
    },
    {
      title: 'Total Messages',
      value: stats.totalMessages || 0,
      icon: '💬',
      color: '#FF9800',
    },
    {
      title: 'Total Threads',
      value: stats.totalThreads || 0,
      icon: '🧵',
      color: '#9C27B0',
    },
  ];

  return (
    <div className="admin-dashboard__stats">
      {statCards.map((card, index) => (
        <div
          key={index}
          className="admin-dashboard__stat-card"
          style={{ borderTopColor: card.color }}
        >
          <div className="admin-dashboard__stat-icon">{card.icon}</div>
          <div className="admin-dashboard__stat-content">
            <h4 className="admin-dashboard__stat-title">{card.title}</h4>
            <p className="admin-dashboard__stat-value">
              {card.value.toLocaleString()}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}

DashboardStats.propTypes = {
  stats: PropTypes.object,
};
